export default __webpack_public_path__ + "static/media/pic-1.cd549e7e.jpg";